export const frequencies = [
  {
    value: "monthly",
    label: "Monthly",
    priceSuffix: "/month",
    checked: true,
    billing_cycle: "month",
  },
  {
    value: "yearly",
    label: "yearly",
    priceSuffix: "/year",
    checked: false,
    billing_cycle: "year",
  },
];

export const tiers = [
  {
    name: "Free",
    id: "free",
    href: "/register",
    price: { monthly: "$0", yearly: "$0" },
    description: "Explore AI-Powered Podcast Insights & Basic Repurposing",
    features: [
      "Preview access to all our features", // Highlights main free offering
      "100 minutes (one-time) of your audio/video processed by AI", // Rephrased minute limit
      "25 AI credits (one-time) for Q&A & AI Content Creation)",
      "10 items in your personal inbox",
    ],
    mostPopular: false,
  },
  {
    name: "Standard",
    id: "standard",
    href: "/register",
    price: { monthly: "$5", yearly: "$50" },
    description: "For Solo Creators & Podcasters to Repurpose Smarter & Faster", // Refined description
    features: [
      "500 minutes/month of your audio/video processed by AI", // More concise
      "50 AI credits monthly (for Q&A & AI Content Creation)",
      "Single Top-up Package Available (1000 processing mins + 100 AI credits)",
      "Access & analyze our library of already-processed public podcasts",
      "Full Access to All AI Repurposing Recipes (Show Notes, Social Posts, Blog Outlines & more)",
      "Save Custom Repurposing Prompts",
      "AI Podcast Title Recommendations (Preview)",
      "AI Chat (AskAI) & Semantic Search Your Content Library",
      "Unlimited personal inbox storage",
      "Upload your own audio/video files (1GB)",
      "Import from YouTube, RSS feeds & direct links",
      "Share processed content insights via link",
      "30+ Language Support",
      "Export to Markdown",
    ],
    coming_features: ["More Export Options", "Key Creator Integrations"],
    mostPopular: false,
  },
  {
    name: "Premium",
    id: "premium",
    href: "/register",
    price: { monthly: "$12", yearly: "$120" },
    description: "For Power Users & Small Teams Scaling Content Output Intelligently", // Refined description
    features: [
      "1200 minutes/month of your audio/video processed by AI", // More concise
      "200 AI credits monthly (for Q&A & AI Content Creation)",
      "Single Top-up Package Available (1000 processing mins + 100 AI credits)",
      "Access & analyze our library of already-processed public podcasts",
      "Full Access to All AI Repurposing Recipes (Show Notes, Social Posts, Blog Outlines & more)",
      "Save Custom Repurposing Prompts",
      "AI Podcast Title Recommendations (Preview)",
      "AI Chat (AskAI) & Semantic Search Your Content Library",
      "Unlimited personal inbox storage",
      "Upload your own audio/video files (10GB)",
      "Import from YouTube, RSS feeds & direct links",
      "Priority processing for your content", // Slightly rephrased
      "Share processed content insights via link",
      "30+ Language Support",
      "Export to Markdown",
    ],
    coming_features: ["Advanced AI Recipes", "More Export Options", "Key Integrations"],
    mostPopular: true,
  },
];